export default __webpack_public_path__ + "static/media/buybook.a81272f3.png";